import { FetchError } from 'ofetch';
import { requestV2Token, requestV3Token } from './controller';

const shouldFallbackToV2 = (error: FetchError) =>
  error.response?.status === 449;

export async function withRecaptcha<T>(
  action: string,
  run: (extra: Record<string, string>) => Promise<T>,
): Promise<T> {
  const v3 = await requestV3Token(action);
  const extra: Record<string, string> = v3 ? { captcha_token: v3 } : {};
  try {
    return await run(extra);
  } catch (err) {
    if (err instanceof FetchError && shouldFallbackToV2(err)) {
      const v2 = await requestV2Token();
      if (!v2) throw err;
      return await run({ ...extra, captcha_v2_token: v2 });
    }
    throw err;
  }
}
